import { Component, Directive, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateUtil } from '../../utils/translate-util';
import { WindowRef } from '../../utils/window';
import { AuthorizationService } from '../authorization/authorization.service';
import { SelectionModel } from '@angular/cdk/collections';
import { UserEntity } from '../../shared/models/UserEntity';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { forEach } from 'jszip';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';
import { SessionTimeoutComponent } from '../sessionTimeout/sessionTimeout.component';

@Component({
    selector: 'div.dtf-adminmfa',
  imports: [SharedTranslateModule, MatTableModule, MatPaginatorModule, SessionTimeoutComponent,ReactiveFormsModule, MatExpansionModule, MatToolbarModule, MatNativeDateModule, MatDatepickerModule, MatFormFieldModule, MatIconModule, MatMenuModule, MatCheckboxModule],
    templateUrl: './adminmfa.component.html',
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class AdminMfaComponent implements OnInit {
  customerNumber: string;
  isAdmin: string;
  language:string;
  bodyLoaded = false;
  dataSource: MatTableDataSource<UserEntity>;
  router: Router;
  usUrl: string;
  caUrl: string;
  userList: UserEntity[];
  isFrench = false;
  selection = new SelectionModel<UserEntity>(false, []);
  openModel = false;
  openUnlockMsgModel = false;
  openInactiveMsgModel = false;
  openReactiveMsgModel = false;
  showEmailUpdateMsg = false;
  showPwdResetMsg = false;
  userId = '';
  currentEmail = '';
  newEmail = '';
  verifyEmail = '';
  emailDontMatch = false;
  // Table columns
  initColumns: any[] = [
    {
      name: 'select',
      display: 'Select',
      displayMobile: '',
      displayFR: '',
      dispFormat: ''
    },
    {
      name: 'userID',
      display: 'User ID',
      displayFR: 'User ID',
      dispFormat: ''
    },

    {
      name: 'email',
      display: 'Email',
      displayFR: 'Email',
      dispFormat: ''
    },
    {
      name: 'userStatus',
      display: 'Status',
      displayFR: 'Status',
      dispFormat: ''
    },
     {
      name: 'lockedStatus',
      display: 'Locked',
      displayFR: 'Locked',
      dispFormat: ''
    },
     {
      name: 'createdDate',
      display: 'Last Login',
      displayFR: 'Last Login',
      dispFormat: ''
    },
    {
      name: 'passwordTimestamp',
      display: 'Password expires on',
      displayFR: 'Password expires on',
      dispFormat: ''
    }
  ];

  displayedColumns: any[] = this.initColumns.map(col => col.name);
  userForm: FormGroup;
  submitted = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  //constructor
  constructor(router: Router, private fb: FormBuilder, public auth: AuthorizationService,
    private _window: WindowRef, private formBuilder: FormBuilder, public translate: TranslateService, public translateUtil: TranslateUtil

  ) {
    this.router = router;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.userList = [];
    this.dataSource = new MatTableDataSource(this.userList);
  }

  ngOnInit() {
    this.isAdmin = sessionStorage.getItem('isAdmin');
    this.language = (window as any).mbfs.language;
    const country = (window as any).mbfs.country;
    this.customerNumber = (window as any).mbfs.customerNumber;
    this.isFrench = ('fr-CA' === this.language) ? true : false;
    this.userForm = this.formBuilder.group({
      verifyEmail: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
    });
    this.getUserList();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  get f() { return this.userForm.controls; }

  buildForm() {
    this.userForm = this.fb.group({
      userId: [''],
      currentEmail: [''],
      newEmail: [''],
      verifyEmail: ['']
    });
  }

  getUserList() {
    let fetchUserListRequest = {};
    fetchUserListRequest = {
      ciamId: this.customerNumber
    };
    this.auth.fetchUserList(fetchUserListRequest).subscribe(res => {
      res.forEach(element => {
        if(element.userStatus === 'A') {
          element.userStatus = 'Active';
        } else if(element.userStatus === 'I') {
          element.userStatus = 'Inactive';
        }
        if(element.lockedStatus === true) {
          element.lockedStatus = 'Yes';
        } else if(element.lockedStatus === false) {
          element.lockedStatus = 'No';
        }
        this.userList.push(element);
      });
      this.dataSource = new MatTableDataSource(this.userList);
      this.dataSource.paginator = this.paginator;
    });
  }

  //unlock code
  unlock(e: Event) {
    if (this.selection?.selected?.length == 0) {
      return;
    }
    let fetchUserListRequest = {};
    fetchUserListRequest = {
      ciamId: this.customerNumber,
      userId: this.selection?.selected[0]?.userID
    };
    this.auth.unlockUser(fetchUserListRequest).subscribe(res => {
      if (res) {
        this.openUnlockMsgModel = true;
        const logReq = {
          adminId: sessionStorage.getItem('loginID'),
          actionType: 'UNLOCK_USER',
          targetUser: this.customerNumber,
          description: 'User account unlocked',
          module: 'USER_MANAGEMENT',
          status: 'SUCCESS'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {  });
      }
    });
  }

  closeMsgModel(e: Event) {
    this.openUnlockMsgModel = false;
    this.openReactiveMsgModel = false;
    this.openInactiveMsgModel = false;
    this.showEmailUpdateMsg = false;
    this.showPwdResetMsg = false;
    window.location.href = this.usUrl + '/home/admindashboard';
  }
  //change email
  changeEmail(e: Event) {
    if (this.selection?.selected?.length == 0) {
      return;
    }
    //clear error messages
    this.emailDontMatch = false;
    this.submitted = false;
    this.buildForm();
    this.userForm.get('newEmail').setValidators(
      Validators.compose([Validators.required,
      Validators.email,
      Validators.minLength(1),
      Validators.maxLength(60),
      Validators.pattern('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[\.]+[a-z]{2,4}$')])
    );

    this.userId = this.selection?.selected[0]?.userID;
    this.currentEmail = this.selection?.selected[0]?.email;
    this.openModel = true;
  }

  closeModal(e: Event) {
    this.openModel = false;
  }

  submitEmail(e: Event) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.userForm.invalid) {
      return;
    }
    if (this.userForm.get('newEmail').value !== this.userForm.get('verifyEmail').value) {
      this.emailDontMatch = true;
      return;
    } else {
      let updateEmailRequest = {};
      updateEmailRequest = {
        ciamId: sessionStorage.getItem('loginID'),
        userId: this.selection?.selected[0]?.userID,
        email: this.userForm.get('newEmail').value
      };
      this.auth.updateEmail(updateEmailRequest).subscribe(res => {
        if (res) {
          this.openModel = false;
          this.showEmailUpdateMsg = true;
          const logReq = {
            adminId: sessionStorage.getItem('loginID'),
            actionType: 'CHANGE_EMAIL',
            targetUser: this.selection?.selected[0]?.userID,
            description: 'Email changed to ' + this.userForm.get('newEmail').value,
            module: 'USER_MANAGEMENT',
            status: 'SUCCESS'
          };
          this.auth.saveAdminAuditLog(logReq).subscribe(res => {  });
        }
      });
    }
  }
  // Reset password code
  resetPassword(e: Event) {
    if (this.selection?.selected?.length == 0) {
      return;
    }
    const passwordRequest = {
      userId: this.selection?.selected[0]?.userID,
      language: this.selection?.selected[0]?.brandId == "3" ? "Admin" : this.language,
      isAdmin: this.isAdmin ? "Y" : "N" 
    };
    this.currentEmail = this.selection?.selected[0]?.email;
    
    this.auth.getPasswordResetStepOne(passwordRequest).subscribe(res => {
      if (res.statusMessage === 'SUCCESS') {
        this.showPwdResetMsg = true;
        const logReq = {
          adminId: sessionStorage.getItem('loginID'),
          actionType: 'RESET_PASSWORD',
          targetUser: this.selection?.selected[0]?.userID,
          description: 'Password reset by admin',
          module: 'USER_MANAGEMENT',
          status: 'SUCCESS'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {  });
      }
      else {
        this.showPwdResetMsg = false;
      }
    });
}

//inactivate
inactivate(e: Event){
  if (this.selection?.selected?.length == 0) {
    return;
  }
  let userRequest = {};
  userRequest = {
      ciamId: this.customerNumber,
      userId: this.selection?.selected[0]?.userID
    };
    this.auth.inactivateUser(userRequest).subscribe(res => {
      if (res) {
        this.openInactiveMsgModel = true;
        this.openReactiveMsgModel = false;

        const logReq = {
          adminId: sessionStorage.getItem('loginID'),
          actionType: 'INACTIVATE_USER',
          targetUser: this.selection?.selected[0]?.userID,
          description: 'User marked inactive',
          module: 'USER_MANAGEMENT',
          status: 'SUCCESS'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {  });

      }
    });
}

reactivate(e: Event){
  if (this.selection?.selected?.length == 0) {
    return;
  }
  let userRequest = {};
  userRequest = {
      ciamId: this.customerNumber,
      userId: this.selection?.selected[0]?.userID
    };
    this.auth.reactivateUser(userRequest).subscribe(res => {
      if (res) {
        this.openReactiveMsgModel = true;
        this.openInactiveMsgModel = false;

        const logReq = {
          adminId: sessionStorage.getItem('loginID'),
          actionType: '.REACTIVATE_USER',
          targetUser: this.selection?.selected[0]?.userID,
          description: 'User reactivated',
          module: 'USER_MANAGEMENT',
          status: 'SUCCESS'
        };
        this.auth.saveAdminAuditLog(logReq).subscribe(res => {  });

      }
    });
}

raiseIncidentTicket(e: Event) {
  if (this.selection?.selected?.length == 0) {
    return;
  }

  const selectedUser: any = this.selection.selected[0] || {};
  const loggedInAgent = sessionStorage.getItem('AdminName') || sessionStorage.getItem('username') || '';
  const shortId = sessionStorage.getItem('agentID') || loggedInAgent;
  const normalizedAgentShortId = loggedInAgent && shortId && loggedInAgent.trim() !== shortId.trim()
    ? `${loggedInAgent} / ${shortId}`
    : (shortId || loggedInAgent || '');

  const incidentPrefill = {
    usernameOfAffectedCustomer: selectedUser.userID || '',
    selectedUserId: selectedUser.userID || '',
    accountNumber: '',
    thirdParty: this.customerNumber || '',
    agentNameShortId: normalizedAgentShortId
  };

  sessionStorage.setItem('incidentPrefill', JSON.stringify(incidentPrefill));
  this._window.nativeWindow.location.href = this.usUrl + '/home/incidentManagement';
}
}// component ends 





